import { useRef, useEffect, useCallback } from 'react';
import axios from 'axios';
import type { CancelTokenSource, CancelToken } from 'axios';
const { CancelToken: _CancelToken, isCancel } = axios;

export type newCancelTokenFn = () => CancelToken;

export const useCancelToken = () => {
  const axiosSource = useRef<CancelTokenSource>(null);
  const newCancelToken = useCallback<newCancelTokenFn>(() => {
    // @ts-ignore
    axiosSource.current = _CancelToken.source();
    return axiosSource.current.token;
  }, []);

  useEffect(
    () => () => {
      if (axiosSource.current) axiosSource.current.cancel();
    },
    [],
  );

  return { newCancelToken, isCancel };
};

export default useCancelToken;
